import React from 'react';
import { translate } from 'react-i18next';
import { Layout } from 'antd';
import { Helmet } from 'react-helmet';
import i18next from 'i18next';
import TextAreaField from 'Parts/ui/components/fields/TextAreaField';
import { Form, Button } from 'antd';
import Error404Page from '../../chore/Error404Page';
import SubmitButton from 'Parts/common/SubmitButton';

import {
    REPORT_MESSAGE_SUCCESS
} from '../../messages/messageActions';

import reportMessageEN from './locales/ReportMessage_en.json';
import reportMessageFR from './locales/ReportMessage_fr.json';

import './ReportMessage.less';

class ReportMessage extends React.Component {
    constructor(props) {
        super(props);
        
        this.state = { messageId: parseInt(props.match.params.messageId) };

        i18next.addResourceBundle('en', 'ReportMessage', reportMessageEN);
        i18next.addResourceBundle('fr', 'ReportMessage', reportMessageFR);

        this.goBack = this.goBack.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
    }

    render() {
        const { form, t } = this.props;

        if(isNaN(this.state.messageId)) {
            return <Error404Page />;
        }

        return (
            <Layout className="ReportMessage">
                <Helmet>
                    <title>{t('Report Message')}</title>
                </Helmet>
                <Form className="report-message-form" onSubmit={this.handleSubmit}>
                    <TextAreaField
                        form={form}
                        fieldId="reasonField"
                        label={t("Reason")}
                        required={true}
                        placeholder={t("WhyAreYouReporting")}
                        maxlength={500}
                        />

                    <div className="CreatePersonalizationForm__SubmitWrapper SubmitWrapper">
                        <Button className="Back-btn small-height" onClick={this.goBack}>
                            {t('back')}
                        </Button>
                        <SubmitButton>
                            {t('Report')}
                        </SubmitButton>
                    </div>
                </Form>
            </Layout>
        )
    }

    handleSubmit(e) {
        e.preventDefault();
        this.props.form.validateFields({ force: true }, (err, values) => {
            if (!err) {
                this.props.reportMessage(this.state.messageId, values.reasonField).then((e) => {
                    if(e.type === REPORT_MESSAGE_SUCCESS) {
                        this.goBack();
                    }
                })
            }
        });
    }

    goBack() {
        this.props.history.goBack();
    }
}

export default translate('ReportMessage')(ReportMessage);
